module.exports = __webpack_public_path__ + "CraftsByMelon.jpg?669c6d1ab0539005ea2c8595bc066dd1";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/CraftsByMelon.jpg
// module id = 455
// module chunks = 0